import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
  // getAllFavouriteGames,
  getCasinoGamesList
  // removeFavouriteGame
} from 'redux-thunk/thunk/game.thunk'
import { getAuthToken } from 'helpers/cookie.helpers'
import { LOADER_HANDLER_TYPES } from 'constants/index'
import Loader from 'components/ui-kit/Loader'
import ProvidersListing from './Components/ProvidersListing'
import CasinoGamesListing from './Components/CasinoGamesListing/index'
import TransactionsTable from 'pages/Home/components/TransactionsTable/index'
import FilteredGames from '../FilteredGames/index'
import { setSearchGame } from 'redux-thunk/redux/slices/lobby.slice'
import OriginalsGames from './Components/OriginalsGames/index'
// TODO UNCOMMENT WHEN POPULAR AND ORIGINALS ARE AVAILABLE
// import PopularGames from './Components/PopularGames/index'
import '../../casino.scss'

function Lobby () {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const isLoggedIn = getAuthToken()
  const { user } = useSelector(state => state?.user)
  const {
    casinoCategoriesList,
    categoryWiseGamesList
    // favouriteGames
  } = useSelector((state) => state.games)
  const { searchGame, gameCategory } = useSelector(state => state?.lobby)
  const { [LOADER_HANDLER_TYPES.content]: loading } = useSelector(state => state.loader)

  const [categoryCount, setCategoryCount] = useState(5)

  const homeCasinoSettings = useMemo(() => (
    {
      initialSlide: 0,
      dots: false,
      infinite: true,
      arrows: true,
      speed: 600,
      autoplay: false,
      slidesToShow: 7,
      slidesToScroll: 7,

      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 8
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
        // {
        //   breakpoint: 480,
        //   settings: {
        //     slidesToShow: 1,
        //     slidesToScroll: 1
        //   }
        // }
      ]
    }
  ), [])

  useEffect(() => {
    if (casinoCategoriesList?.length < 5) {
      setCategoryCount(casinoCategoriesList?.length)
    }
  }, [casinoCategoriesList])

  const fetchMore = () => {
    if (isLoggedIn) {
      user && casinoCategoriesList?.slice(categoryCount, categoryCount + 5)?.map(({ gameCategory }) => {
        if (gameCategory !== 'Slots') {
          dispatch(getCasinoGamesList({ data: { offset: 0, limit: 12, type: gameCategory, userId: user?.id } }))
        }
        return null
      })
    } else {
      casinoCategoriesList?.slice(categoryCount, categoryCount + 5)?.map(({ gameCategory }) => {
        if (gameCategory !== 'Slots') {
          dispatch(getCasinoGamesList({ data: { offset: 0, limit: 12, type: gameCategory } }))
        }
        return null
      })
    }
  }

  useEffect(() => {
    dispatch(setSearchGame(''))
  }, [gameCategory])

  return (
    <>
      {searchGame.length > 0 && <FilteredGames />}

      {/* //TODO UNCOMMENT WHEN POPULAR AND ORIGINALS ARE AVAILABLE
      <PopularGames homeCasinoSettings={homeCasinoSettings} /> */}
      <OriginalsGames homeCasinoSettings={homeCasinoSettings} />
      <CasinoGamesListing
        // includeSlots
        homeCasinoSettings={homeCasinoSettings}
        categoryCount={categoryCount}
      />
      <ProvidersListing homeCasinoSettings={homeCasinoSettings} />

      {categoryWiseGamesList?.length !== 0 &&
        <div className='mb-1'>
          {loading && <Loader variant={LOADER_HANDLER_TYPES.content} />}
          <div className='d-flex justify-content-center'>
            <button
              className='btn btn-secondary'
              disabled={categoryWiseGamesList?.length >= casinoCategoriesList?.length}
              onClick={() => {
                if (categoryWiseGamesList?.length !== casinoCategoriesList?.length) {
                  fetchMore()
                }
                setCategoryCount((prev) => prev + 5)
                dispatch(setSearchGame(''))
              }}
            >
              {t('showMore')}
            </button>
          </div>
        </div>}
      <TransactionsTable />
    </>
  )
}

export default Lobby
